import { useNavigate } from 'react-router-dom'
import { useNewsArticles, urlFor } from '@autoplan/web-sanity'
import { Heading, Stack } from '@autoplan/web-ui'
import { NewsCard } from '../components/Cards/NewsCard'
import { detectLang } from '../utils/locale'

export const Articles = () => {
  const articles = useNewsArticles()
  const navigate = useNavigate()
  const lang = detectLang()

  return (
    <main className="ap:min-h-screen ap:pb-7xl">
      <div className="ap:w-[85%] ap:mx-auto">
        <Stack spacing="xl">
          <Heading size="lg">{lang === 'en' ? 'News' : 'Nyheter'}</Heading>
          {articles.map((article) => (
            <NewsCard
              key={article._id}
              title={article.title ?? ''}
              introduction={''}
              imageSrc={article.image ? (urlFor(article.image)?.width(300).height(150).url() ?? undefined) : undefined}
              onClick={() => article.slug && navigate(`/articles/${article.slug.current}`)}
            />
          ))}
        </Stack>
      </div>
    </main>
  )
}
